module.exports = __webpack_public_path__ + "img/addCircle.6d7d98bd.svg";